import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import {Link, useParams} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import PoliciesResponsesTable from './PoliciesResponsesTable';
import { Form } from 'semantic-ui-react';
import GlobalRegionalDistributionGraphs from './GlobalRegionalDistributionGraphs';
import 'semantic-ui-css/semantic.min.css';
import DownloadDataGlobal from './DownloadDataGlobal';
import DownloadDataRegional from './DowloadDataRegional';
import UtilsLocalizedString from '../../../services/utilsLocalizedString';

function DataPoliciesResponses(props) {
 
      const [terrListFromServer, setTerrListFromServer] = useState("");
      const [allServerData, setAllServerData] = useState("");
      const [dataSelectedTerr, setDataSelectedTerr] = useState("");
      const[serverCalled, setServerCalled] = useState(false);
      const { t } = useTranslation();
      const [selectedOption, setSelectedOption] = useState(null);
      const [selectedGraphsSection, setSelectedGraphsSection] = useState('target_A1');
      const [dataForGraphsGlobal, setDataForGraphsGlobal] = useState('');
      const [dataForGraphsRegional, setDataForGraphsRegional] = useState('');

      let { id } = useParams();


      const setTerrAndFilterRecords = (e,{ value, options }) => {
        const selectedOption = options.find(elem => elem.value === value);
       const { value: selectedValue, text} = selectedOption;
   
       if(value != null) {
        setDataSelectedTerr(allServerData.filter((terr) => terr.territory.id === value)[0].answers)
        setSelectedOption({value: value, label: text});
       }

      }




    useEffect(() => {
        const fetchData = async () => {
        if(serverCalled === false) {
          fetch(`${process.env.REACT_APP_BACKEND_API}/submission/report/all/`, {
            method: "GET",
             headers: {
             "accept": "application/json",
               "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
             },
   })
     .then((response) => response.json())
     .then((data) => {
      const refactoredData = data.map(sub => ({ 
      key:sub.territory.id,
      value : sub.territory.id,
      text: sub.territory.iso3 + " " + UtilsLocalizedString(props.lang, sub.territory)
    })).sort((a, b) => a.text.localeCompare(b.text));

        const refactorForGrapsRegional = [];
        data.forEach((terr) => {
          var region = terr.territory.region.name
            refactorForGrapsRegional.push(
              { region : region,
                answers: terr.answers
              }
            )});
      
            var regionList = ['Africa', "Asia", "Europe", "LAC", "Near East", "N America", "SW Pacific"];
            var onlyOneRegion = [];
            var regionAnswers = [];
            regionList.forEach((region) => {
              onlyOneRegion = [];
                refactorForGrapsRegional.filter(obj => obj.region === region).map((obj) => onlyOneRegion.push(...obj.answers));
               
                regionAnswers.push(onlyOneRegion);

            });
           var globalData = [];
           data.forEach((arr) => globalData.push(...arr.answers));
      setDataForGraphsGlobal(globalData);
      setDataForGraphsRegional(regionAnswers);
      setAllServerData(data);
      setTerrListFromServer(refactoredData);
      setServerCalled(true);
     })
     .catch((error) => console.log(error));
          setServerCalled(true);
        }
      };
  
      fetchData();
  }, [props.lang, id, serverCalled]);
 

    return (
    <React.Fragment>   


        <div className="App" style={{marginTop: "2rem"}}>
      <h5 className="title-body-general">{t('policies_responses')}</h5>
      <br></br>
     


     <Container >
      <Row>

        <Col xs={12} sm={12} md={3} > 
          <Button onClick ={() => [ setSelectedOption(null), setDataSelectedTerr(null)]} className={`full-height button-padding button-${id === "global" ? "is-active" : "is-not-active"}`} variant="light" size="lg"><Link style={{textDecoration: "none"}} to={`/silvagris/${props.lang}/data/policies-responses/global`}>
          <h1 className="data-button">{t('global_coverage')}</h1></Link>
          </Button>
        </Col>

        <Col xs={12} sm={12} md={3}>
          <Button  onClick ={() => [setSelectedOption(null), setDataSelectedTerr(null)]}  className={`full-height button-padding button-${id === "regional" ? "is-active" : "is-not-active"}`} variant="light" size="lg"><Link  style={{textDecoration: "none"}} to={`/silvagris/${props.lang}/data/policies-responses/regional`}>
          <h1 className="data-button">
          {t('regional_coverage')}</h1></Link>
          </Button>
        </Col>

        <Col  xs={12} sm={12} md={3}>
          <Button  className={`full-height button-padding button-${id === "country" ? "is-active" : "is-not-active"}`} variant="light" size="lg"><Link style={{textDecoration: "none"}} to={`/silvagris/${props.lang}/data/policies-responses/country`}>
          <h1 className="data-button">
          {t('country_coverage')}</h1></Link>
          </Button>
        </Col>


        {id === "country" && terrListFromServer !== null && Array.isArray(terrListFromServer) ? 
        <Col xs={12} sm={12} md={3}>  


        
         <Form.Select
          search
          selection
          className="button-padding"
          id="country"
          options={terrListFromServer}
          placeholder={selectedOption !== null ? selectedOption.text : t('select_country')}
          onChange={setTerrAndFilterRecords}
            />
       </Col> : null} 
      </Row>
    </Container> </div>
    {id !== "country" ? 
    <div className="App">
       <br></br>
      <br></br>
    <Container  >
       <h5 className="title-body">{t('select_target')}</h5>
      <br></br>
     <Row>

        <Col md xs={12} sm={12}> 
          <Button onClick ={() => [setSelectedGraphsSection('target_A1'), setSelectedOption(null), setDataSelectedTerr(null)]} 
          className={`full-height button-padding button-${selectedGraphsSection === "target_A1" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
          <h1 className="data-button">{t('target_A1')}</h1>
          </Button>
        </Col>

        <Col md xs={12} sm={12}>
          <Button  onClick ={() => [setSelectedGraphsSection('target_A2'),setSelectedOption(null), setDataSelectedTerr(null)]}  
          className={`full-height button-padding button-${selectedGraphsSection === "target_A2" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
          <h1 className="data-button">
          {t('target_A2')}</h1>
          </Button>
        </Col>

        <Col md xs={12} sm={12} >
           <Button  onClick ={() => [ setSelectedGraphsSection('target_A3'),setSelectedOption(null), setDataSelectedTerr(null)]}  
           className={`full-height button-padding button-${selectedGraphsSection === "target_A3" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
          <h1 className="data-button">
          {t('target_A3')}</h1>
          </Button>
        </Col>

        <Col md xs={12} sm={12} >
            <Button  onClick ={() => [ setSelectedGraphsSection('target_A4'),setSelectedOption(null), setDataSelectedTerr(null)]}  
            className={`full-height button-padding button-${selectedGraphsSection === "target_A4" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
          <h1 className="data-button">
          {t('target_A4')}</h1>
          </Button>
        </Col>

        <Col md style={{ gap: "13px" }} xs={12} sm={12}>
            <Button  onClick ={() => [setSelectedGraphsSection('target_B4'),setSelectedOption(null), setDataSelectedTerr(null)]}  
            className={`full-height button-${selectedGraphsSection === "target_B4" ? "is-active" : "is-not-active"}`} variant="light" size="lg">
          <h1 className="data-button">
          {t('target_B4')}</h1>
          </Button>
        </Col>
        </Row>
    </Container></div> : <div></div>}
      {id === "global" &&
      <DownloadDataGlobal type="global"/>}
      {id === "regional" &&
     <DownloadDataRegional type="regional"/>}


    {id === "country" ? 
   
    <PoliciesResponsesTable  country={selectedOption} dataFiltered={dataSelectedTerr}/> 
    
    : allServerData !== undefined && allServerData !== ""  && dataForGraphsRegional !== "" ? 
    <GlobalRegionalDistributionGraphs 
    type={id} 
    target={selectedGraphsSection} 
    dataRegional={dataForGraphsRegional} 
    dataGlobal={dataForGraphsGlobal}/> : <div></div>}

     
      
      
      </React.Fragment>
    );
  }

  export default DataPoliciesResponses;